export const EDIT = 'Edit';
export const DELETE = 'Delete';

export const ORG_MENU_OPTION = [
    { label: EDIT, value: EDIT },
    { label: DELETE, value: DELETE },
];

export const INFO_POINTS = ['Seamless user additions', 'Streamlined updates', 'Real time data synchronisation'];
